import { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import AuthenticatedLayout from './AuthenticatedLayout'

interface ProtectedRouteProps {
  children: ReactNode
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, isLoading } = useAuth()
  const location = useLocation()
  
  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
        <p className="mt-4 text-lg text-gray-600">Loading your account...</p>
      </div>
    )
  }
  
  // If not authenticated, redirect to login with return URL
  if (!user) {
    console.log('User not authenticated, redirecting to login with return URL:', location.pathname + location.search);
    // Encode the current path as a return URL parameter
    const returnUrl = encodeURIComponent(location.pathname + location.search)
    return <Navigate to={`/login?returnUrl=${returnUrl}`} replace />
  }
  
  // User is authenticated, render children with trial banner
  return <AuthenticatedLayout>{children}</AuthenticatedLayout>
}
